import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axiosInstance from '../utility/axiosInstance';
import { RootState } from '../store/store';
import InstanceDetailsModal from '../components/InstanceDetailsModal';
import { Instance } from '../store/slices/instancesSlice';

const InstanceDetailsPage: React.FC = () => {
    const { instanceId } = useParams();
    const navigate = useNavigate();
    const [instance, setInstance] = useState<Instance | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const instances = useSelector((state: RootState) => state.instances.data);

    useEffect(() => {
        if (!instanceId) return;

        const localInstance = instances.find(inst => inst.id === instanceId);
        if (localInstance) {
            setInstance(localInstance);
            setLoading(false);
        } else {
            setLoading(true);
            axiosInstance.get(`/v1/instances/${instanceId}`)
                .then(res => {
                    setInstance(res.data.instance);
                    setLoading(false);
                })
                .catch(err => {
                    console.error("Failed to fetch instance", err);
                    setError("Instance not found or could not be loaded.");
                    setLoading(false);
                });
        }
    }, [instanceId, instances]);

    const handleClose = () => navigate('/category/compute/instances/');

    if (loading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
                <div className="fancyspinner">
                    <div className="ring"></div>
                    <div className="ringouter"></div>
                    <div className="dot"></div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', gap: 12 }}>
                <div style={{ color: '#e74c3c', fontSize: 16 }}>{error}</div>
                <button onClick={handleClose} className="btn btn-secondary">Back to Instances</button>
            </div>
        );
    }

    return (
        <>
        {instance?.provisioning_mode==='free' && <aside className="registration-billing__notice">
            Included VM. {instance.traffic_paused && 'Public traffic is paused; private networking and disks are preserved. '}
            <a href="/category/user/billing">Review included allowance</a>
        </aside>}
        <InstanceDetailsModal
            open={!!instance}
            onClose={handleClose}
            instance={instance}
        />
        </>
    );
};

export default InstanceDetailsPage;
